<template>
    <div class="dialog-rebet" v-if="dialog">
        <div class="dialog-rebet__overlay"></div>
        <div class="dialog-rebet__container">
            <div class="text-h8 dialog-rebet__title">
                <span class="dialog-rebet__title__red">{{ getTranslatedText('attention') }}</span>
                <span v-if="reprintCount < reprintCountToShowCancel">{{ getTranslatedText("your transaction has been confirmed") }}</span>
                <span v-if="reprintCount >= reprintCountToShowCancel">{{ getTranslatedText("your ticket has been reprinted") }}</span>
            </div>

            <div v-if="reprintCount < reprintCountToShowCancel" class="dialog-rebet__description">{{ getTranslatedText("please press \"yes\" to confirm whether the ticket has been printed, or \"no\" to reprint the ticket.".replace(/ \(\d+\)/g, "")) }}</div>
            <div v-if="reprintCount >= reprintCountToShowCancel" class="dialog-rebet__description">{{ getTranslatedText("please press \"yes\" to confirm whether the ticket has been printed, or \"no\" to cancel the ticket.".replace(/ \(\d+\)/g, "")) }}</div>
            <div class="dialog-rebet__button">
                <ButtonCommon
                    v-if="reprintCount >= reprintCountToShowCancel"
                    value="non - cancel"
                    class-name="dialog__box-button__item uppercase"
                    :isNoHover="true"
                    :isLoading="isUpdating || isDevicePrinting"
                    @on-click-button-common="cancelBetslip()"
                />
                <ButtonCommon
                    v-if="reprintCount < reprintCountToShowCancel"
                    value="non - reprint"
                    class-name="dialog__box-button__item uppercase"
                    :isNoHover="true"
                    :isLoading="isUpdating || isDevicePrinting"
                    @on-click-button-common="reprint()"
                />
                <ButtonCommon
                    value="yes"
                    class-name="dialog__box-button__item uppercase"
                    :isNoHover="true"
                    :isLoading="isUpdating || isDevicePrinting"
                    @on-click-button-common="updatePrintingStatus()"
                />
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from '@/utils/EventBus';
import BetslipsService from '@/services/betslip/betslip.service.ts';

import languageMixins from '@/mixins/language-mixins';
import printMixins from '@/mixins/print-mixins';

import ButtonCommon from '@/components/common/button/button.vue';

import { isArrayEmpty, isStrEmpty } from '@/utils/utils'
import { LOTTO_INSTANT } from '@/constants/lotto/instant-lotto';

export default {
    mixins: [languageMixins, printMixins],
    components: { ButtonCommon },
    data() {
        let data =
        {
            dialog: false,
            reference: "",
            ticketType: "",
            isUpdating: false,
            isDevicePrinting: true,
            printStatusMessage: '',
            paramPrint: null,
            reprintCount: 0,
            shouldIncreasePrintedCount: false,
            reprintCountToShowCancel: this.$store.state.reprintCountToShowCancel ?? 3,
            millisecondsToForceFinishPrinting: this.$store.state.millisecondsToForceFinishPrinting ?? 4000,
            forSport: false,
            forLotto: false,
            forLottoType: '',
            betslipId: ''
        };
        return data;
    },
    mounted() {
        document.addEventListener('message', this.handlePrintMessageFromApk)
    },
    created() {
        EventBus.on("on-show-reprint", (param) => {
            this.dialog = true;
            this.shouldIncreasePrintedCount = false
            this.reprintCount = 0
            this.paramPrint = param.paramPrint
            this.betslipId = param.betslipId;
            this.reference = param.reference;
            this.ticketType = param.ticketType;
            this.forSport = param?.forSport;
            this.forLotto = param?.forLotto;
            this.forLottoType = param?.forLottoType;
            this.$store.dispatch('setIsReprintShow', true);
            this.initTimeoutToForceFinishPrinting()
        });
    },
    unmounted() {
        EventBus.off("on-show-reprint");
    },

    methods: {
        async updatePrintingStatus() {
            if (this.isUpdating === true) return;

            // todo: update ui, not allow to call api when device is not finish printing (OPTIONAL)

            this.isUpdating = true;

            await BetslipsService.updatePrintingStatus(this.ticketType, this.reference, this.reprintCount)

            // todo: need to check response?

            this.isUpdating = false;
            this.dialog = false;

            this.shouldIncreasePrintedCount = false
            this.reprintCount = 0
            this.isDevicePrinting = false

            this.$store.dispatch('setIsReprintShow', false);

            if (this.forLotto && this.forLottoType === LOTTO_INSTANT.SLUG_GAME && this.betslipId) {
                const ticketId = this.betslipId.startsWith('L-') ? this.betslipId : `L-${this.betslipId}`;

                if (this.$route.path !== '/scan') {
                    this.$router.push({ path: '/scan', query: this.$route.query }).then(() => {
                        this.$nextTick(() => {
                            EventBus.emit('on-show-ticket-detail', {
                                data: null,
                                ticketId: ticketId,
                                ticketType: 'L'
                            });
                        });
                    });
                } else {
                    EventBus.emit('on-show-ticket-detail', {
                        data: null,
                        ticketId: ticketId,
                        ticketType: 'L'
                    });
                }
            }
        },

        async cancelBetslip() {
            if (this.isUpdating === true) return;
            this.isUpdating = true;

            try {
                const resp = await BetslipsService.cancelBetslip(this.betslipId)
                if (resp.code === 200) {
                    let message = ''
                    !isArrayEmpty(resp.errors)
                        ? resp.errors.forEach((element) => {
                            message += element.message
                        })
                        : message = resp?.data?.message || ''
                    const param = {
                        text: !isStrEmpty(message) ? message : 'cancel successfully',
                        type: 'success',
                    }
                    EventBus.emit('show-notications', param)

                    this.dialog = false
                    this.$store.dispatch('setIsReprintShow', false);
                    this.$router.push({ path: '/', query: this.$route.query} )
                } else {
                    let message = ''
                    !isArrayEmpty(resp.errors)
                        ? resp.errors.forEach((element) => {
                            message += element.message
                        })
                        : (message = resp.message)
                    const param = {
                        text: message,
                        type: 'error',
                        className: 'up-first'
                    }
                    EventBus.emit('show-notications', param)
                }
            } catch (error) {
                const param = {
                    text: 'System error',
                    type: 'error',
                    className: 'up-first'
                }
                EventBus.emit('show-notications', param)
            }

            this.isUpdating = false;
        },

        async reprint() {
            this.shouldIncreasePrintedCount = true;
            this.isDevicePrinting = true
            this.initTimeoutToForceFinishPrinting()

            if (this.forSport === true) {
                this.printSports(this.paramPrint, true)
            }

            if (this.forLotto === true) {
                switch (this.forLottoType) {
                    case LOTTO_INSTANT.SLUG_GAME:
                        this.printLottoInstant(this.paramPrint, true)
                        break;
                    default:
                        this.printLottoDaily(this.paramPrint, true)
                        break;
                }

            }
        },

        initTimeoutToForceFinishPrinting() {
            setTimeout(() => {
                if (this.shouldIncreasePrintedCount === true) {
                    this.shouldIncreasePrintedCount = false
                    this.reprintCount++;
                }
                this.isDevicePrinting = false
            }, this.millisecondsToForceFinishPrinting);
        }
    },
};
</script>

<style lang="scss">
@import "@/public/scss/common/dialog-rebet.scss";
</style>
